<script setup>
import { computed, onMounted, ref } from 'vue';
import { __, currentMonth } from '@/utils';
import ModalDatepicker from '@components/accountMain/parts/modal-datepicker.vue';

const currentValue = ref('curr_month');
const tempCurrentValue = ref('curr_month');
const open = ref(false);
const dateModal = ref(false);
const refSelect = ref(null);
const acceptedRange = ref([]);

defineProps(['subscriber']);
const emit = defineEmits(['selectedDateRange'])

const currentDate = new Date();
const timeRange = [
    { id: 'curr_month', name: __('Current month'), icon: false },
    { id: 'last_month', name: __('Previous month'), icon: false },
    { id: 'date_range', name: __('Select a date range'), icon: true },
];

const selected = computed(() => timeRange.find(item => item.id === currentValue.value));
const dateRangeOtput = computed(() => {
	if(acceptedRange.value.length === 0) {
		return '';
	}

	const first = acceptedRange.value[0].toLocaleDateString();
	const second = acceptedRange.value[1].toLocaleDateString();
	return `${first} - ${second}`;
});


const handleChange = (selectedOption) => {
    if (selectedOption.id === 'curr_month') {
        emit('selectedDateRange', currentMonth());
    }

    if (selectedOption.id === 'last_month') {
        const startOfLastMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
        const endOfLastMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

        const startDate = formatDate(startOfLastMonth);
        const endDate = formatDate(endOfLastMonth);

        emit('selectedDateRange', `${startDate},${endDate}`);
    }

    if (selectedOption.id === 'date_range') {
        dateModal.value = true;
    }
};

const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');
    
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const acceptDate = (data) => {
    dateModal.value = false;
    const startDate = formatDate(data[0]);
    const endDate = formatDate(data[1]);
	acceptedRange.value = data;
    
    emit('selectedDateRange', `${startDate},${endDate}`);

	tempCurrentValue.value = 'date_range';
}

const handleSelect = (item) => {
	currentValue.value = item.id;
	handleChange(item);
	if(item.id !== 'date_range') {
		tempCurrentValue.value = item.id;
	}
	open.value = false;
};

const handleClose = () => {
	dateModal.value = false;
	currentValue.value = tempCurrentValue.value;
};

onMounted(() => {
	window.addEventListener('click', (e) => {
		if (!refSelect.value?.contains(e.target)) {
			open.value = false;
		}
	});

	window.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			open.value = false;
		}
	});
});
</script>

<template>
	<div class="range-select" :class="{ 'range-select--open': open }" ref="refSelect">
		<button type="button" class="range-select__selected" @click="open = !open">
			<template v-if="currentValue != 'date_range'">
				{{ selected.name }}
			</template>
			<template v-if="currentValue === 'date_range'">
				{{ dateRangeOtput }}
			</template>
		</button>
		<ul class="range-select__dropdown" v-if="open">
			<li class="range-select__item" v-for="item in timeRange" :key="item.id">
				<div class="range-select__item__content" @click="handleSelect(item)">
					<span>{{ item.name }}</span>
					<img class="range-select__icon" v-if="item.icon" :src="`${theme_path.url}/resources/images/svg/icon-calendar.svg`"/>
				</div>
			</li>
		</ul>
	</div>
	<ModalDatepicker
		@close="handleClose"
		@accept="acceptDate"
		:active="dateModal" 
		:title="__('Select a date range')"
		:subtext="__('Please select a date range to view the usage details for line') + ' ' + subscriber?.name"
	/>
</template>